module.exports = __webpack_public_path__ + "img/service-tab-img7.ba881bf9.png";